module.exports = __webpack_public_path__ + "img/hkie.3fa3c663.png";